import { loadStripe, Stripe } from "@stripe/stripe-js";

// Gift-card Stripe payments are currently Canada-only.
const STRIPE_PUBLISHABLE_KEY = process.env.GATSBY_STRIPE_API_KEY_CA;

const stripePromises: { [key: string]: Promise<Stripe | null> } = {};

export function getStripePublishableKey(): string | undefined {
  return STRIPE_PUBLISHABLE_KEY;
}

export function getStripePromise(): Promise<Stripe | null> | null {
  const key = getStripePublishableKey();
  if (!key) return null;
  if (!stripePromises[key]) {
    stripePromises[key] = loadStripe(key);
  }
  return stripePromises[key];
}
